/* @sravni/react-header version 0.2.43 */
var generateUrl = function (path, domain) {
    var hasDomain = typeof domain === 'string';
    var base = hasDomain ? domain : 'http://test.com';
    var url = new URL(path, base);
    if (!hasDomain)
        return "" + url.pathname + url.search;
    return url.toString();
};
var makeRelAttribute = function (config) {
    if (!config)
        return '';
    var withNoReferrerParams = config.href.indexOf('promo=1') > -1 || config.href.indexOf('noreferrer=1') > -1;
    //@ts-ignore TODO исправить после обновления типизации
    var noReferrer = withNoReferrerParams || config.noreferrer ? 'noreferrer' : undefined;
    var noFollow = config.nofollow ? 'nofollow' : undefined;
    var rel = [noReferrer, noFollow].filter(function (tag) { return tag; }).join(' ');
    return rel || undefined;
};

export { generateUrl, makeRelAttribute };
//# sourceMappingURL=links.js.map
